module.exports = __webpack_public_path__ + "static/media/home-employer.727a6d2a.jpeg";